import React, { useEffect, useState } from 'react';
import AppBar from '@mui/material/AppBar';
import Box from '@mui/material/Box';
import Toolbar from '@mui/material/Toolbar';
import IconButton from '@mui/material/IconButton';
import Typography from '@mui/material/Typography';
import Menu from '@mui/material/Menu';
import MenuIcon from '@mui/icons-material/Menu';
import Container from '@mui/material/Container';
import Avatar from '@mui/material/Avatar';
import Button from '@mui/material/Button';
import Tooltip from '@mui/material/Tooltip';
import MenuItem from '@mui/material/MenuItem';
import { observer } from 'mobx-react';
import { useNavigate } from 'react-router-dom';
import AuthStore from '../../store/AuthStore';
import PersonIcon from '@mui/icons-material/Person';
import shortLogo from '../../assets/images/shortLogo.png';
import {
  Badge,
  Collapse,
  Divider,
  List,
  ListItem,
  ListItemButton,
  ListItemIcon,
  ListItemText,
  Stack,
  SwipeableDrawer,
  styled,
} from '@mui/material';
import {
  AddAPhoto,
  AllInclusive,
  CameraAlt,
  ExpandLess,
  ExpandLessOutlined,
  ExpandMore,
  Logout,
  ManageAccounts,
  Person,
  Schema,
  Settings,
  Task,
} from '@mui/icons-material';
import UserStore from '../../store/UserStore';
import { BrowseProfilePictureDialog } from '../BrowseProfilePictureDialog';
import { UserSettingsDrawer } from '../UserSettingsDrawer';

export const AppNavbar = observer(({}) => {
  const navigate = useNavigate();
  const [anchorElNav, setAnchorElNav] = useState(null);
  const [anchorElUser, setAnchorElUser] = useState(null);
  const [activeMenu, setActiveMenu] = useState('home');

  // useEffect(() => {
  //   console.log(activeMenu)
  //   document.querySelectorAll('#header-nav-buttons button')
  //     ?.forEach(ele => {
  //       ele.innerText.toLowerCase() === activeMenu
  //         ? ele.classList.add('active')
  //         : ele.classList.remove('active')
  //     })
  // }, [activeMenu])

  const handleOpenNavMenu = (event) => {
    setAnchorElNav(event.currentTarget);
  };
  const handleOpenUserMenu = (event) => {
    setAnchorElUser(event.currentTarget);
  };

  const handleLogout = () => {
    AuthStore.logout();
  };
  const [toggleUserSettingsDrawer, setToggleUserSettingsDrawer] = useState(false);

  const handleCloseNavMenu = () => {
    setAnchorElNav(null);
  };

  const handleCloseUserMenu = () => {
    setAnchorElUser(null);
  };

  const handleUserSettingsDrawer = () => {
    setToggleUserSettingsDrawer(!toggleUserSettingsDrawer);
  };

  const CustomButton = styled(Button)({
    '&.active': {
      borderBottom: '2px solid #fff',
      borderRadius: '0',
      marginBottom: '4px',
      marginTop: '10px',
    },
  });

  const CustomAppBar = styled(AppBar)({
    '& .MuiToolbar-root.MuiToolbar-regular': {
      height: '50px',
      minHeight: '50px',
    },
  });

  const pages = [
    {
      title: 'Home',
      onClickHandle: () => {
        navigate('/home');
        window.location.reload();
      },
    },
    {
      title: 'Status',
      onClickHandle: () => navigate('/status'),
    },
  ];

  return (
    <CustomAppBar id="lm-app-bar" position="fixed">
      {/* <Container maxWidth="xl"> */}
      <Toolbar disableGutters>
        <Typography
          variant="h6"
          noWrap
          sx={{
            display: { xs: 'none', sm: 'flex' },
            fontFamily: 'monospace',
            fontWeight: 700,
            letterSpacing: '.3rem',
            color: 'inherit',
            textDecoration: 'none',
          }}
        >
          <img src={shortLogo} style={{ height: '3rem', marginTop: '4px' }} alt="app-logo" />
        </Typography>
        <Box sx={{ flexGrow: 1, display: { xs: 'flex', sm: 'none' } }}>
          <IconButton
            size="large"
            aria-label="account of current user"
            aria-controls="menu-appbar"
            aria-haspopup="true"
            onClick={handleOpenNavMenu}
            color="inherit"
          >
            <MenuIcon />
          </IconButton>
          <Menu
            id="menu-appbar"
            anchorEl={anchorElNav}
            anchorOrigin={{
              vertical: 'bottom',
              horizontal: 'left',
            }}
            keepMounted
            transformOrigin={{
              vertical: 'top',
              horizontal: 'left',
            }}
            open={Boolean(anchorElNav)}
            onClose={handleCloseNavMenu}
            sx={{
              display: { xs: 'block', sm: 'none' },
            }}
          >
            {pages.map((page) => (
              <MenuItem key={page.title} onClick={page.onClickHandle}>
                <Typography textAlign="center">{page.title}</Typography>
              </MenuItem>
            ))}
          </Menu>
        </Box>
        <Typography
          variant="h5"
          noWrap
          sx={{
            mr: 2,
            display: { xs: 'flex', sm: 'none' },
            flexGrow: 1,
            fontFamily: 'monospace',
            fontWeight: 700,
            letterSpacing: '.3rem',
            color: 'inherit',
            textDecoration: 'none',
          }}
        >
          <img src={shortLogo} style={{ height: '3rem' }} alt="app-logo" />
        </Typography>
        <Box id="header-nav-buttons" sx={{ flexGrow: 1, display: { xs: 'none', sm: 'flex' } }}>
          {pages.map((page) => (
            <CustomButton
              key={page.title}
              onClick={page.onClickHandle}
              sx={{ my: 2, color: 'white', display: 'block' }}
            >
              {page.title}
            </CustomButton>
          ))}
        </Box>
        <Box sx={{ flexGrow: 0 }}>
          <Tooltip title="Open settings">
            <IconButton onClick={handleUserSettingsDrawer} sx={{ p: 0 }}>
              {UserStore.userImage ? (
                <Avatar alt={AuthStore.userDetails.Name} src={UserStore.userImage}></Avatar>
              ) : (
                <Avatar alt={AuthStore.userDetails.Name}>
                  <PersonIcon></PersonIcon>
                </Avatar>
              )}
            </IconButton>
            <IconButton onClick={handleUserSettingsDrawer} sx={{ color: 'white' }}>
              <MenuIcon />
            </IconButton>
          </Tooltip>
        </Box>
      </Toolbar>
      {/* </Container> */}
      <UserSettingsDrawer
        toggleUserSettingsDrawer={toggleUserSettingsDrawer}
        handleUserSettingsDrawer={handleUserSettingsDrawer}
      ></UserSettingsDrawer>
    </CustomAppBar>
  );
});
